var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailure = function SvgFailure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_146492)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA4AE",
    d: "M48.79 10.2a1.129 1.129 0 1 1 .003 2.257 1.129 1.129 0 0 1-.003-2.258M48.79 39.65a1.129 1.129 0 1 1 .003 2.258 1.129 1.129 0 0 1-.003-2.258M43.13 46.45c1.25 0 2.27 1.01 2.27 2.27s-1.01 2.27-2.27 2.27-2.27-1.01-2.27-2.27 1.01-2.27 2.27-2.27M40.86 0a1.129 1.129 0 1 1 .002 2.258A1.129 1.129 0 0 1 40.86 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60019",
    d: "M25 3.4C12.49 3.4 2.35 13.54 2.35 26.05s10.14 22.66 22.66 22.66 22.66-10.14 22.66-22.66S37.51 3.4 25 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 43.05c-9.38 0-16.99-7.61-16.99-16.99s7.61-17 16.99-17 16.99 7.61 16.99 16.99S34.38 43.04 25 43.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA4AE",
    d: "M8.01 48.71a1.129 1.129 0 1 1 .002 2.259 1.129 1.129 0 0 1-.002-2.258M5.18 2.27c1.56 0 2.83 1.27 2.83 2.83S6.74 7.93 5.18 7.93 2.35 6.66 2.35 5.1s1.27-2.83 2.83-2.83M1.21 11.33a1.129 1.129 0 1 1 .002 2.258 1.129 1.129 0 0 1-.002-2.258M1.21 39.65a1.129 1.129 0 1 1 .002 2.258 1.129 1.129 0 0 1-.002-2.258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60019",
    d: "M19.2 34.62c-.58 0-1.15-.22-1.59-.66-.88-.88-.88-2.3 0-3.18l12.53-12.53c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18L20.79 33.96c-.44.44-1.02.66-1.59.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60019",
    d: "M31.73 34.62c-.58 0-1.15-.22-1.59-.66L17.61 21.43c-.88-.88-.88-2.3 0-3.18s2.3-.88 3.18 0l12.53 12.53c.88.88.88 2.3 0 3.18-.44.44-1.01.66-1.59.66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_146492"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.08 0h49.84v50.98H.08z"
  })))));
};
export default SvgFailure;